import {
	Alert,
	AlertDescription,
	AlertTitle,
} from '@dealstack/frontend/shared/components/Alert/Alert';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import styled from 'styled-components';

/**
 * Shown when the programme's proof requirements could not be loaded. The toggles below read all
 * off in that state, which is not the programme's answer, so they are disabled and left unsaved —
 * this says so rather than letting the step pass for a programme that asks for nothing.
 */
export const ProgrammeProofsUnavailableAlert = () => {
	const tMipManage = useTranslationMipManage();

	// Alert forwards only className, so the test id goes on a wrapper.
	return (
		<Wrapper data-testid={TEST_ELEMENT_IDS.NEW_JOINERS_AND_ALLOCATIONS_PROOFS_UNAVAILABLE}>
			<Alert size="m" state="danger" icon="warning">
				<AlertTitle>{tMipManage('new_joiner.kyc.proofs_unavailable.title')}</AlertTitle>
				<AlertDescription>
					{tMipManage('new_joiner.kyc.proofs_unavailable.description')}
				</AlertDescription>
			</Alert>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	margin: 1em 0;
`;
